import classNames from 'classnames'
import parse from 'html-react-parser'
import { useTranslation } from 'next-i18next/pages'
import { ContactCtaProps } from './types'
import styles from './ContactCta.module.scss'
import { Language } from 'types/language'
import { Card, Heading, Img } from '@boltenergy-be/design-system'
import { isWeekend } from 'utils/dayjs'
import { useGetLanguage } from 'hooks/useGetLanguage'

const ContactCta = ({ avatarPublicId, className, description, title }: ContactCtaProps) => {
  // i18n
  const { t } = useTranslation('lookingForHelp')
  const language = useGetLanguage()

  // Support availability
  const available = isWeekend() === false

  return (
    <Card className={classNames(styles.contact, className)} color="dark">
      {avatarPublicId && (
        <Img
          className={styles.thumbnail}
          publicId={avatarPublicId}
          fill
          alt=""
          steps={300}
          sizes="(max-width: 620px) 140px, (max-width: 920px) 170px, 205px"
        />
      )}

      <div className={styles.content}>
        <Heading as="h2" variant="h3" serif>
          {parse(title)}
        </Heading>
        <p>{parse(description)}</p>
        <p className={styles['with-links']}>
          <a href="tel:028993300">02 899 33 00</a>{' '}
          {parse(
            language === Language.DUTCH
              ? 'of <a href="mailto:hallo@boltenergie.be">hallo@boltenergie.be</a>'
              : 'ou <a href="mailto:bonjour@boltenergie.be">bonjour@boltenergie.be</a>'
          )}
        </p>
        <p className={styles.posttext}>
          {available ? t('available', 'We zijn vandaag bereikbaar tot 17:00') : t('unavailable', 'We zijn maandag bereikbaar vanaf 9:00')}
        </p>
      </div>
    </Card>
  )
}

ContactCta.defaultProps = {
  hasDarkBg: false
}

export default ContactCta
